module.exports = __webpack_public_path__ + "static/media/couple.175567f1.jpg";